import * as React from "react";
import { WizardHotelPWAFlexComponent } from "../typings";
import { UitkCheckbox } from "uitk-react-switch";
import { locKeys } from "./l10n";
import { useLocalization } from "@shared-ui/localization-context";

export const AddCar = ({
  flexComponent,
  changeFormProperties,
  isCarAdded,
  disablePackageOptions
}: {
  flexComponent: WizardHotelPWAFlexComponent;
  isCarAdded: boolean;
  changeFormProperties: (event: React.ChangeEvent<HTMLFormElement>) => void;
  disablePackageOptions?: boolean;
}) => {
  if (!flexComponent.model.enableAddCar) {
    return null;
  }

  const { formatText } = useLocalization();

  return (
    <div className="packageCheckbox all-r-padding-three">
      <UitkCheckbox
        id="addCar"
        label={formatText(locKeys.addCarLabel)}
        checked={isCarAdded}
        onChange={changeFormProperties}
        disabled={disablePackageOptions}
      />
    </div>
  );
};
